<template>
  <div class="i-career-roadmap">
    <div class="header">
      <div>The JobTest <strong>Career Roadmap.</strong></div>
      <div class="row-list">
        <div class="detail">Increase Income</div>
        <div class="detail">Job Satisfaction</div>
        <div class="detail">Career Advancement</div>
      </div>
    </div>
    <div class="main">
      <div
        id="one"
        class="card"
      >
        <div class="text">
          <div class="title">AI-Powered Insights</div>
          <div>Get tailored career advice based on your profile.</div>
        </div>
        <div class="image">
          <img
            class="pics"
            :src="isLgOrLarger ? Image1 : Image1Mob"
          />
        </div>
      </div>
      <div
        id="two"
        class="card"
      >
        <div class="text">
          <div class="title">Progress Tracking</div>
          <div>Monitor your trajectory and achievements.</div>
        </div>
        <div class="image">
          <img
            class="pics"
            :src="isLgOrLarger ? Image2 : Image2Mob"
          />
        </div>
      </div>
      <div
        id="three"
        class="card"
      >
        <div class="text">
          <div class="title">Personality Matching</div>
          <div>Find careers that match your personality.</div>
        </div>
        <div class="image">
          <img
            class="pics"
            :src="isLgOrLarger ? Image3 : Image3Mob"
          />
        </div>
      </div>
      <div
        id="four"
        class="card"
      >
        <div class="text">
          <div class="title">Expert Coaching</div>
          <div>Access to professional career coaches.</div>
        </div>
        <div class="image">
          <img
            class="pics"
            :src="isLgOrLarger ? Image4 : Image4Mob"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { breakpointLg } from "@/styles/variables"

import useIsScreenSize from "@/composables/useIsScreenSize"

// ASSETS
import Image1 from "@/assets/welcome/ai-results.webp"
import Image2 from "@/assets/welcome/progress-tracking.svg"
import Image3 from "@/assets/welcome/personality-matching.svg"
import Image4 from "@/assets/welcome/expert-coaching.webp"
import Image1Mob from "@/assets/welcome/ai-results-mob.webp"
import Image2Mob from "@/assets/welcome/progress-tracking-mob.svg"
import Image3Mob from "@/assets/welcome/personality-matching-mob.svg"
import Image4Mob from "@/assets/welcome/expert-coaching-mob.webp"

// COMPOSABLES
const isLgOrLarger = useIsScreenSize(breakpointLg)
</script>

<style scoped lang="scss">
.i-career-roadmap {
  @include flex(column, center, center, $gap: 45px);

  padding: 50px 15px;
  background-image: url("@/assets/confirm/bg-gradient-multi.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;

  @media screen and (min-width: $breakpoint-md) {
    padding: 60px 15px;
    gap: 60px;
  }

  .header {
    @include display-md;
    @include flex(column, start, center, $gap: 20px);

    text-align: center;

    @media screen and (min-width: $breakpoint-md) {
      @include display-lg;
    }

    .row-list {
      @include flex(row, center, center, wrap, $gap: 6px 20px);
      @include text-sm;

      font-weight: 400;

      .detail {
        @include flex(row, start, center);

        color: $black950;
        list-style: none;

        &::before {
          content: "";
          display: inline-block;
          height: 20px;
          width: 25px;
          background-image: url("@/assets/icons/icon-green-check.svg");
          background-repeat: no-repeat;
        }
      }
    }
  }

  .main {
    @include flex(column, start, center, $gap: 16px);

    width: 100%;
    max-width: 750px;

    @media screen and (min-width: $breakpoint-lg) {
      @include grid($cols: repeat(5, 1fr), $rows: auto, $align-items: stretch, $gap: 16px);

      grid-template-areas: "one one one two two" "three three four four four";
      max-width: 960px;
    }

    @media screen and (min-width: $breakpoint-xl) {
      max-width: 1410px;
    }

    .card {
      @include flex(column, space-between, stretch, $gap: 40px);
      @include border-radius-md;

      overflow: hidden;
      text-align: center;
      background-color: #fff6;
      padding-top: 25px;
      width: 100%;
      max-width: 500px;

      @media screen and (min-width: $breakpoint-sm) {
        padding-top: 40px;
      }

      @media screen and (min-width: $breakpoint-lg) {
        width: unset;
        max-width: unset;
      }

      .text {
        @include flex(column, center, center, $gap: 10px);
        @include text-sm;

        padding: 0 15px;

        .title {
          @include display-xs;

          @media screen and (min-width: $breakpoint-xl) {
            @include display-sm;
          }
        }
      }

      .image {
        padding-left: 15px;

        @media screen and (min-width: $breakpoint-lg) {
          padding-left: 0;
        }

        .pics {
          width: 100%;

          @media screen and (min-width: $breakpoint-lg) {
            width: unset;
            max-height: 230px;
          }

          @media screen and (min-width: $breakpoint-xl) {
            max-height: 280px;
          }
        }
      }

      img {
        float: right;
      }
    }

    #one {
      grid-area: one;

      @media screen and (min-width: $breakpoint-lg) {
        img {
          float: unset;
        }
      }
    }

    #two {
      grid-area: two;

      @media screen and (min-width: $breakpoint-lg) {
        padding-left: 24px;
      }
    }

    #three {
      grid-area: three;

      @media screen and (min-width: $breakpoint-lg) {
        padding-right: 24px;

        img {
          float: left;
        }
      }
    }

    #four {
      grid-area: four;

      @media screen and (min-width: $breakpoint-lg) {
        img {
          float: unset;
        }
      }
    }
  }
}
</style>
